module.exports = __webpack_public_path__ + "img/Jasper - Head scratch.97905d00.png";